import moment from "moment";
import "moment-timezone";
import geoloc from "tz-lookup";
import store from "../store/store";
import {getFarm} from "../selectors/farmSelector";

export function getFarmTimeZoneFromObject(farm) {
    try {
        if (Array.isArray(farm.FarmCord)) {
            return geoloc(farm.FarmCord[0], farm.FarmCord[1]);
        } else {
            let cords = farm.FarmCord.split(",");
            let x = 0;
            let y = 0;
            if (farm.FarmCord.includes("'")) {
                x = +cords[0].split("'").join(".") || 0;
                y = +cords[1].split("'").join(".") || 0;
            } else {
                x = +cords[0] || 0;
                y = +cords[1] || 0;
            }
            return geoloc(x, y);
        }
    } catch (e) {
        console.error(e);
        return moment.tz.guess(true);
    }
}

export function getFarmZoneType(FarmID) {
    let farmTimezone = moment.tz.guess(true);
    if (FarmID) {
        try {
            let farm = getFarm(store.getState(), FarmID);
            if (Array.isArray(farm.FarmCord)) {
                farmTimezone = geoloc(farm.FarmCord[0], farm.FarmCord[1]);
            } else {
                let cords = farm.FarmCord.split(",");
                let x = 0;
                let y = 0;
                if (farm.FarmCord.includes("'")) {
                    x = +cords[0].split("'").join(".") || 0;
                    y = +cords[1].split("'").join(".") || 0;
                } else {
                    x = +cords[0] || 0;
                    y = +cords[1] || 0;
                }
                farmTimezone = geoloc(x, y);
            }
            return farmTimezone;
        } catch (e) {
            console.error(e);
            farmTimezone = moment.tz.guess(true);
        }
    }
    return farmTimezone;
}

export function getWorkTime(worktime = null) {
    if (worktime) {
        let s = Math.floor((worktime / 1000) % 60);
        let m = Math.floor((worktime / (1000 * 60)) % 60);
        let h = Math.floor((worktime / (1000 * 60 * 60)) % 24);
        let d = Math.floor(worktime / (1000 * 60 * 60 * 24));
        let seconds = s < 10 ? "0" + s : s;
        let minutes = m < 10 ? "0" + m : m;
        let hours = h < 10 ? "0" + h : h;
        let days = d < 10 ? "0" + d : d;
        return days + ":" + hours + ":" + minutes + ":" + seconds;
    } else return "-";
}

export const getFormattedDate = (ts) => moment(ts).format("DD.MM.YY");

const DURATION_ALIASES = {
    ms: "ms",
    millisecond: "ms",
    milliseconds: "ms",

    s: "s",
    sec: "s",
    secs: "s",
    second: "s",
    seconds: "s",

    m: "m",
    min: "m",
    mins: "m",
    minute: "m",
    minutes: "m",

    h: "h",
    hr: "h",
    hrs: "h",
    hour: "h",
    hours: "h",

    d: "d",
    day: "d",
    days: "d",

    w: "w",
    wk: "w",
    wks: "w",
    week: "w",
    weeks: "w",
};

const UNIT_TO_MS = {
    ms: 1,
    s: 1000,
    m: 60 * 1000,
    h: 60 * 60 * 1000,
    d: 24 * 60 * 60 * 1000,
    w: 7 * 24 * 60 * 60 * 1000,
};

/**
 * Akceptuje:
 * - "hour" / "1 hour" / "2hours"
 * - "5min" / "5 mins" / "5 minutes"
 * - "1m" / "1h" / "30s" / "250ms"
 * Zwraca ms albo null jeśli nie rozpozna.
 */
export function parseDurationToMs(input) {
    if (input == null) return null;
    const str = String(input).trim().toLowerCase();
    if (!str) return null;

    // dopuszczamy: "5min", "5 min", "min", "1 minute", "2hours", "1h"
    const match = str.match(/^(\d+(?:\.\d+)?)?\s*([a-z]+)$/i);
    if (!match) return null;

    const amount = match[1] == null ? 1 : Number(match[1]);
    const rawUnit = match[2];

    const unitKey = DURATION_ALIASES[rawUnit];
    if (!unitKey) return null;

    return amount * UNIT_TO_MS[unitKey];
}

/**
 * Skaluje wartość z sourceDuration do destinationDuration.
 * Przykład: hour -> 5min => dzieli przez 12
 */
export function scaleValueByDuration(
    value,
    sourceDuration,
    destinationDuration
) {
    const v = Number(value);
    if (!Number.isFinite(v)) return value;

    const sourceMs = parseDurationToMs(sourceDuration);
    const destMs = parseDurationToMs(destinationDuration);
    if (!sourceMs || !destMs) return value;

    const factor = sourceMs / destMs; // ile "dest" mieści się w "source"
    if (!Number.isFinite(factor) || factor === 0) return value;

    return v / factor;
}
